import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import {Translate} from "../../../../config/Translate";
import MenuItem from "@material-ui/core/MenuItem/MenuItem";
import axios from "axios";
import {defaultVariabls} from "../../../../config";
import {connect} from "trim-redux";
import TextField from "@material-ui/core/TextField/TextField";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import withWidth from "@material-ui/core/withWidth/withWidth";
import {withSnackbar} from "notistack";
import {withRouter} from "react-router";
import {withStyles} from "@material-ui/core";
import {Styles} from "../../../../config/design/styles";
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import IconButton from "@material-ui/core/IconButton/IconButton";
import Grid from "@material-ui/core/Grid/Grid";
import InputAdornment from "@material-ui/core/InputAdornment/InputAdornment";
import LoadingButton from "../../../components/elements/LoadingButton";
import ChatRoundedIcon from '@material-ui/icons/ChatRounded';
import validator from "validator";
import {updateRedux} from "../../../../config/Security";
import {shopTypesWithName} from "../../../../config/Permissions";
import PassField from "../../fields/PassField";
import Alert from "@material-ui/lab/Alert/Alert";
import Link from "@material-ui/core/Link/Link";

class GetUserFirstInfoDialog extends React.Component{
    state = {
        fields: {
            first_name: '',
            last_name: '',
            email:'',
            mobile:'',
            role:'user',
            password:'',
            password_confirmation: '',
            shop_type:'normal'
        },
        errors:{},
        SubmitLoading:false,
        loading:true,
        open:false,
        anchorEl:null
    };

    // Function to check if a string contains only Persian characters
    isPersian(text) {
        const persianRegex = /^[\u0600-\u06FF\s]+$/;
        return persianRegex.test(text);
    }

    componentDidMount() {
        let {user} = this.props;
        if(!user.last_name || !user.first_name){
            this.setState({
                open:true,
            })
        }
    }

    handleChange(e){
        let {fields,errors} = this.state;
        let target = e.target;
        errors[target.name] = "";

        // Validate Persian characters for first_name and last_name
        if (target.name === 'first_name' || target.name === 'last_name') {
            if (!this.isPersian(target.value)) {
                errors[target.name] = Translate.persianOnly;
                this.setState({
                    errors
                });
                return;
            }
        }

        fields[target.name] = target.value;
        this.setState({
            fields,
            errors
        });
    }

    handleValidation(callback){
        let { fields ,policy_confirmation} = this.state;
        let errors = {};
        let formIsValid = true;

        //last_name
        if(validator.isEmpty(fields.last_name)){
            formIsValid = false;
            errors['last_name'] = Translate.emptyField;
        } else if (!this.isPersian(fields.last_name)) {
            formIsValid = false;
            errors['last_name'] = Translate.persianOnly;
        }

        //first_name
        if(validator.isEmpty(fields.first_name)){
            formIsValid = false;
            errors['first_name'] = Translate.emptyField;
        } else if (!this.isPersian(fields.first_name)) {
            formIsValid = false;
            errors['first_name'] = Translate.persianOnly;
        }

        //Email
        if(validator.isEmpty(fields.email)){

        }else if(!validator.isEmail(fields.email)){
            formIsValid = false;
            errors['email'] = Translate.wrongEmail;
        }

        //Password
        if(validator.isEmpty(fields.password)){
            formIsValid = false;
            errors['password'] = Translate.emptyPassword;
        }else if(fields.password.length < 4){
            formIsValid = false;
            errors['password'] = Translate.weakPassword;
        }
        //Password_confirmation
        if(validator.isEmpty(fields.password_confirmation)){
            formIsValid = false;
            errors['password_confirmation'] = Translate.emptyField;
        }else if (fields.password_confirmation !== fields.password){
            formIsValid = false;
            errors['password_confirmation'] = Translate.noMatchPassword;
        }
        if(!!fields.email){
            //check Email and Mobile
            let data = new FormData();
            data.append('email', fields.email);
            const loginToken = localStorage.getItem('ACT');
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            const request = async () => {
                if(errors['email'] === undefined){
                    await axios.post(`${defaultVariabls.url}/register/checkEmail`, data, config)
                        .then(response => {}).catch(error => {
                            console.log(error.response)
                            formIsValid = false;
                            errors['email'] = Translate.existEmail;
                        });
                }

                await this.setState({errors},() =>{
                    if(!formIsValid){
                        this.props.enqueueSnackbar(Translate.someFieldsHasError, {
                            variant: 'warning',
                        });
                        this.setState({
                            SubmitLoading:false
                        })
                    }
                    return callback(formIsValid)
                });
            }
            request();
        }else{
            this.setState({errors},() =>{
                if(!formIsValid){
                    this.props.enqueueSnackbar(Translate.someFieldsHasError, {
                        variant: 'warning',
                    });
                    this.setState({
                        SubmitLoading:false
                    })
                }
                return callback(formIsValid)
            });
        }

    }

    handleRequest(){
        const {fields} = this.state;
        let {user} = this.props;
        let data = new FormData();
        data.append('first_name', fields.first_name);
        data.append('last_name', fields.last_name);
        data.append('email', fields.email);
        data.append('password', fields.password);
        data.append('password_confirmation', fields.password_confirmation);
        data.append('id', user.id);

        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        axios.post(`${defaultVariabls.url}/user/complete_info`, data, config)
            .then(response => {
                updateRedux();
                this.setState({
                    SubmitLoading:false,
                    open:false
                });

            })
            .catch(error => {
                console.log(error.response)
                this.props.enqueueSnackbar(Translate.detailsSetFailed, {
                    variant: 'error',
                });
                this.setState({
                    SubmitLoading:false
                });
            });
    }

    handleSubmit(e){
        this.setState({
            SubmitLoading:true
        })
        e.preventDefault();
        this.handleValidation((valid) =>{
            if(valid) {
                this.handleRequest();
            }

        });
    }

    render(){
        let {loading,SubmitLoading,departments,errors,fields,open,type,orderItems,anchorEl} = this.state;
        let {user} = this.props;
        return (
            <>
                <Dialog
                    open={open}
                    aria-labelledby="form-dialog-title"
                    fullWidth
                    maxWidth="sm"
                >
                    <DialogTitle id="form-dialog-title" style={{position:"relative"}}>
                        {Translate.completeInfo}

                    </DialogTitle>
                    <DialogContent>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Alert severity="info" variant={"outlined"}>
                                    {Translate.SubmitInfoHint}
                                </Alert>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField
                                    required
                                    fullWidth
                                    id="first_name"
                                    size="small"
                                    variant="outlined"
                                    label={Translate.first_name}
                                    placeholder={Translate.first_name}
                                    name="first_name"
                                    onChange={this.handleChange.bind(this)}
                                    autoFocus
                                    error = {!!errors['first_name']}
                                    helperText={errors['first_name']}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField
                                    required
                                    fullWidth
                                    id="last_name"
                                    variant="outlined"
                                    label={Translate.last_name}
                                    placeholder={Translate.last_name}
                                    size="small"
                                    name="last_name"
                                    onChange={this.handleChange.bind(this)}
                                    error = {!!errors['last_name']}
                                    helperText={errors['last_name']}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    id="email"
                                    label={Translate.email}
                                    name="email"
                                    size="small"
                                    dir="ltr"
                                    autoComplete="email"
                                    onChange={this.handleChange.bind(this)}
                                    error = {!!errors['email']}
                                    helperText={errors['email']}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <PassField
                                    required
                                    fullWidth
                                    variant="outlined"
                                    name="password"
                                    label={Translate.password}
                                    type="password"
                                    id="password"
                                    size="small"
                                    onChange={this.handleChange.bind(this)}
                                    error = {!!errors['password']}
                                    helperText={errors['password']}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <PassField
                                    required
                                    variant="outlined"
                                    fullWidth
                                    name="password_confirmation"
                                    label={Translate.passwordConfirm}
                                    placeholder={Translate.passwordConfirm}
                                    type="password"
                                    size="small"
                                    id="password_confirmation"
                                    onChange={this.handleChange.bind(this)}
                                    error = {!!errors['password_confirmation']}
                                    helperText={errors['password_confirmation']}
                                />
                            </Grid>
                            <Grid item xs={12} style={{
                                display: "flex",
                                alignItems:"center",
                                justifyContent: "center"
                            }}>
                                <Button
                                    variant="outlined"
                                    component={"a"}
                                    style={{marginLeft:10}}
                                    href={`${defaultVariabls.website}/`}
                                >
                                    {Translate.back}
                                </Button>
                                <LoadingButton
                                    variant="contained"
                                    color="primary"
                                    onClick = {this.handleSubmit.bind(this)}
                                    loading = {SubmitLoading}
                                >
                                    {Translate.setDetails}
                                </LoadingButton>

                            </Grid>
                        </Grid>
                    </DialogContent>
                </Dialog>
            </>
        );
    }
}

const mstp = state => ({
    user: state.user,
});

export default withWidth()(withSnackbar(withRouter(withStyles(Styles)(connect(mstp)(GetUserFirstInfoDialog)))));